import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Order from "@/model/Order.model";
import { inject, onMounted, reactive, ref } from "vue";
import OrderList from "@/components/admin/OrderList.vue";
import { OrderServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderListView',
    setup(__props) {
        const orderService = inject(OrderServiceSymbol);
        const orders = reactive([]);
        const search = ref('');
        onMounted(() => {
            orderService.loadOrders().then((response) => {
                response.data.forEach(order => {
                    const typedOrder = new Order();
                    typedOrder.assign(order);
                    orders.push(typedOrder);
                });
            });
        });
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, {
                        fluid: true,
                        class: "d-flex flex-wrap ma-0 pa-0"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, {
                                fluid: true,
                                class: "d-flex"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "text-h4 text-start pa-0 ma-0" }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode(" Buchungen ")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_container, { class: "ma-0 pa-0 d-flex justify-end" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                "data-cy": "search",
                                                modelValue: search.value,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                                                label: "Suche",
                                                class: "v-col-6 pa-0 pr-4",
                                                density: "compact"
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_v_btn, {
                                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$router.push('/admin/orders/new'))),
                                                "data-cy": "new-order"
                                            }, {
                                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                    _createTextVNode("Hinzufügen")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_container, {
                                fluid: true,
                                class: "pt-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(OrderList, {
                                        orders: orders,
                                        search: search.value
                                    }, null, 8, ["orders", "search"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
